module.exports = __webpack_public_path__ + "static/media/CTARight.1ccb6e16.svg";